import React, { useEffect, useState } from "react";
import { alpha, Box, styled, Typography } from "@mui/material";
import { useClock } from "../../lib/hooks/useQueryBoard";

const TimeWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  position: "fixed",
  width: "100%",
}));

const Time = styled(Typography)(({ theme }) => ({
  minWidth: "28rem", // around 86px on 484x919 screen
  padding: "0 5rem",
  fontSize: "6rem",
  borderRadius: "0 0 2rem 2rem",
  borderWidth: "0.2rem",
  display: "flex",
  justifyContent: "center",
  color: theme.palette.common.white,
}));

const formatTime = (number: number) => number.toString().padStart(2, "0");

const TimeDisplay: React.FC<{ opacity?: number }> = ({ opacity }) => {
  const [timeString, setTimeString] = useState<string>();

  useEffect(() => {
    const interval = setInterval(() => {
      const date = new Date();
      const currentTimeString = `${formatTime(date.getHours())}:${formatTime(
        date.getMinutes(),
      )}`;
      setTimeString(() => currentTimeString);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!timeString) {
    return null;
  }

  return (
    <Time
      sx={{
        backgroundColor: (theme) => {
          if (opacity === 0) {
            return "transparent";
          }

          return alpha(theme.palette.common.black, (opacity ?? 100) / 100);
        },
      }}
    >
      {timeString}
    </Time>
  );
};

const Clock = () => {
  const clock = useClock();

  if (!clock?.enabled) {
    return null;
  }

  return (
    <TimeWrapper>
      <TimeDisplay opacity={clock?.opacity} />
    </TimeWrapper>
  );
};

export default Clock;
